/* eslint-disable no-undef */
import React, { useState } from "react";
import "../CustomerPreview.scss";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import ReviewInput from "../../../components/ReviewInput";
import { Grid, Tooltip } from "@mui/material";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
import edit from "../../../assets/icons/ic-solar_pen-bold.svg";
import disabledEdit from "../../../assets/icons/disabled-edit.svg";
import { useHistory, useParams } from "react-router-dom";
import {
  BOOKING_FORM_STATUS,
  BOOKING_AS,
} from "../../../config/constant";
import {
  setIsFromPreview,
  setEditPreviewApplicant,
  setShowSaveAndPreview,
} from "../../new-booking-form/new-booking-form.slice";

const CompanyDocuments = ({ applicantData, bookingDocuments }) => {
  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(null);
  const [fieldName, setFieldName] = useState("");
  const { entity } = useSelector((state) => state?.newBookingForm);
  const dispatch = useDispatch();
  const history = useHistory();
  const { oppId } = useParams();

  const documents = applicantData?.companyDetails?.documents || {};
// Build docConfig dynamically
const getDocConfig = () => {
  const baseDocs = [
    {
      key: "gstCertificate",
      label: t("companyDocument.labels.gstCertificate", { entity }),
    },
    {
      key: "pan",
      label: t("companyDocument.labels.companyPANcard", { entity }),
    },
  ];

  switch (applicantData?.bookingAs) {
    case BOOKING_AS.CORPORATE:
      return [
        ...baseDocs,
        {
          key: "incorporationCertificate",
          label: t("companyDocument.labels.incorporationCertificate", { entity }),
        },
        {
          key: "memorandumOfAssociation",
          label: t("companyDocument.labels.memorandumofAssociation", { entity }),
        },
        {
          key: "articlesOfAssociation",
          label: t("companyDocument.labels.articlesofAssociation", { entity }),
        },
        {
          key: "boardResolutionPurchase",
          label: t("companyDocument.labels.boardResolution", { entity }),
        },
      ];

    case BOOKING_AS.PARTNERSHIP_FIRM:
      return [
        ...baseDocs,
                {
          key: "partnershipDeed",
          label: t("companyDocument.labels.partnershipDeed", { entity }),
        },
        {
          key: "partnersResolutionPurchase",
          label: t("companyDocument.labels.partnersResolution", { entity }),
        }

      ];

    default:
      return baseDocs;
  }
};

const docConfig = getDocConfig();

  const handleView = (name) => {
    setFieldName(name);
    setOpenPopup(true);
  };

  return (
    <div className="kycDocument">
      <div className="applicantDetailsCard">
        <div
          className="editTitleRow"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3 className="titlePersonalHD">
            {t("preview.companyDocuments", { entity })}
          </h3>{" "}
          {applicantData?.isCompleted !== true ? (
            <div
              className="editButton"
              onClick={() => {
                dispatch(setIsFromPreview({ value: true, index: 1 }));
                dispatch(setShowSaveAndPreview(true))
                dispatch(setEditPreviewApplicant(true));
                history.push(`/booking-form/${oppId}`);
              }}
            >
              <img src={edit} alt="Edit" /> {t("button.edit")}
            </div>
          ) : (
            <Tooltip
              enterTouchDelay={0}
              title={
                applicantData?.bookingFormStatus ===
                BOOKING_FORM_STATUS?.SIGNED_OFFLINE
                  ? t("preview.tooltip.signedOffline")
                  : applicantData?.bookingFormStatus !==
                    BOOKING_FORM_STATUS?.PARTIALLY_SIGNED
                  ? applicantData?.leegalityData?.isSignLater === true
                    ? t("preview.tooltip.signInLater")
                    : t("preview.tooltip.signNow")
                  : undefined
              }
              arrow
            >
              <div className="editButtonDisabled">
                <img src={disabledEdit} alt="Edit" /> {t("button.edit")}
              </div>
            </Tooltip>
          )}
        </div>

        <Grid container rowSpacing={2} columnSpacing={10} mt={1}>
          {/* Render base company documents */}
          {docConfig?.map((doc) => (
            <Grid item xs={12} sm={6} md={6} lg={6} key={doc?.key}>
              <ReviewInput
                text={doc?.label}
                name={doc?.key}
                onView={handleView}
                disabled={!(documents[doc?.key]?.length)}
              />
            </Grid>
          ))}


        </Grid>
      </div>

      {openPopup && (
        <UploadPopup
          heading="View"
          totalImages={1}
          closePopup={() => setOpenPopup(false)}
          uploadedImage={
            documents[fieldName] ||
            bookingDocConfig?.find((d) => d?.key === fieldName)?.file ||
            []
          }
          fieldName={fieldName}
          hidePhysicalCopyOption
          dynamicSize={1}
          hideCameraOption={false}
          showDeleteIcon={false}
        />
      )}
    </div>
  );
};

export default CompanyDocuments;
